import api from './api';

// Which medication UI/data model a clinic's meetings use.
export type MedicationType = 'IL' | 'UK_ADHD';

export const MEDICATION_TYPE_LABELS: Record<MedicationType, string> = {
  IL: 'IL',
  UK_ADHD: 'UK ADHD',
};

export interface Service {
  id: number;
  name: string;
  medication_type: MedicationType;
  meeting_type_ids: number[]; // ordered meeting flow
  tenant_id: number;
  created_at: string;
  updated_at: string;
}

export interface ServiceCreate {
  name: string;
  medication_type: MedicationType;
  meeting_type_ids: number[];
}

export interface ServiceUpdate {
  name?: string;
  medication_type?: MedicationType;
  meeting_type_ids?: number[];
}

const servicesService = {
  getAll: async (tenantId: number): Promise<Service[]> => {
    const response = await api.get('/services/', { params: { tenant_id: tenantId } });
    return response.data;
  },
  create: async (tenantId: number, data: ServiceCreate): Promise<Service> => {
    const response = await api.post(`/services/?tenant_id=${tenantId}`, data);
    return response.data;
  },
  update: async (id: number, data: ServiceUpdate): Promise<Service> => {
    const response = await api.put(`/services/${id}`, data);
    return response.data;
  },
  delete: async (id: number): Promise<void> => {
    await api.delete(`/services/${id}`);
  },
};

export default servicesService;
